













import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "brands-table": () =>
      import("@/components/app/admin/settings/brands/brandsTable.vue")
  }
})
export default class Brands extends Vue {
  public get cta() {
    return this.$userCan("create_brand")
      ? this.$t("_action.create_object", {
          object: (this.$t("_.brand") as string).toLowerCase()
        })
      : null;
  }
}
